import { observable } from "mobx";
import { CalculatedPeriodHelper, ViewHelper } from "../../../helpers/view";
import { PulseBetMarketAdditionalData } from "../../ViewModel";

export class BasicPulseBetViewModel {

    protected viewHelperDependency: ViewHelper;
    protected calculatedPeriodHelperDependency: CalculatedPeriodHelper;

    @observable stake: number;
    pulseBetMetadata: PulseBetMarketAdditionalData;

    constructor(stake: number, pulseBetMetadata: PulseBetMarketAdditionalData, gameProgressInMilli: number) {

        this.viewHelperDependency = ViewHelper.getInstance();
        this.calculatedPeriodHelperDependency = CalculatedPeriodHelper.getInstance();

        this.stake = stake;
        this.pulseBetMetadata = pulseBetMetadata;
    }

    setViewHelperDependency(viewHelper: ViewHelper) {
        this.viewHelperDependency = viewHelper;
    }

    setCalculatedPeriodHelperDependency(calculatedPeriodHelper: CalculatedPeriodHelper) {
        this.calculatedPeriodHelperDependency = calculatedPeriodHelper;
    }
}